import useFetch from '../hooks/useFetch'
import '../../config/i18n'
import useMultilineTextUrl from '../hooks/useMultilineTextUrl'

export default function CacheMultilineText ({
    localizationKey
}) {
    const url = useMultilineTextUrl(localizationKey)
    // fetch the url and cache it
    useFetch({ url, defaultValue: '', json: false })

    // no render
    return null
}
